import { render, staticRenderFns } from "./ListContent.vue?vue&type=template&id=60638940&"
import script from "./ListContent.vue?vue&type=script&lang=js&"
export * from "./ListContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/ListContent.vue"
export default component.exports